import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #fff;
`;

export const TabHeader = styled(Flex)`
  border-bottom: 1px solid #dededf;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
`;

export const TabHeaderItem = styled(Flex).attrs({
  flex: 1,
  align: 'center',
  justify: 'center',
})`
  .title {
    position: relative;
    color: rgba(0, 0, 0, 0.85);
    font-size: 12px;
    line-height: 40px;
    cursor: pointer;
    transition: all ease 0.4s;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${(props) => props.theme.antd.colorPrimary};
      opacity: 0;
      transition: opacity ease 0.4s;
    }
  }
  &.active {
    .title {
      color: ${(props) => props.theme.antd.colorPrimary};
      &:after {
        opacity: 1;
      }
    }
  }
`;
